import React from 'react';
import PropTypes from 'prop-types';
import { Box, Center, Divider, Flex, Text, Image, Hide, HStack } from '@chakra-ui/react';
import Cloud from '../../../assets/Cloud';
import logo from '../../../assets/logo-small.svg';

const AuthTitle = ({ children }) => {
  return (
    <Flex height={'100%'} maxH={'100%'} w="100%" justifyContent={'center'} pt={'10%'}>
      <Box w="100%" p={2}>
        <Box display="flex" justifyContent="center">
          <Flex alignItems={'center'} justifyContent={'center'}>
            <Hide below="md">
              <Center height="44px">
                <Image src={logo} alt={'logo'} />
              </Center>
              <Center height="44px" mx={'20px'}>
                <Divider orientation="vertical" borderColor={'#425570'} />
              </Center>
              <Box mr={'10px'}>
                <Cloud fill={'#AA1F2E'} width={'40px'} height={'40px'} />
              </Box>
            </Hide>
            <HStack>
              <Hide above="md">
                <Center height="44px">
                  <Image src={logo} alt={'logo'} width={'30px'} height={'30px'} />
                </Center>
                <Center height="30" mx={'20px'}>
                  <Divider orientation="vertical" borderColor={'#425570'} />
                </Center>
              </Hide>
              <Text
                fontWeight={700}
                fontSize={{ base: 20, md: 36 }}
                lineHeight={'36px'}
                color={'#11284b'}
                textTransform={'uppercase'}
              >
                Radon Management Cloud
              </Text>
            </HStack>
          </Flex>
        </Box>
        {children}
      </Box>
    </Flex>
  );
};

AuthTitle.propTypes = {
  children: PropTypes.any,
};

export default AuthTitle;



// WEBPACK FOOTER //
// src/components/login/AuthTitle/AuthTitle.jsx